import module from 'nominas/nomina/module.js'
import template from './template.html'

const ranges = (items, key) => {
  return items
    .map((item) => item[key])
    .sort((a, b) => (a < b) ? -1 : ((a > b) ? 1 : 0))
    .reduce((array, item) => {
      let last = array[array.length - 1]
      if (last && (last[last.length - 1] + 1 === item)) {
        last.push(item)

        return array
      }

      return [...array, [item]]
    }, [])
    .map((item) => item.length === 1 ? item : [item[0], item[item.length - 1]])
    .map((item) => item.join('-')).join(', ')
}

export class nominasNominaDispersionPagosImprimirConfirmarComponent {
  idProyecto
  idNomina
  data
  omitidos
  onClose
  cuentaRetiro = undefined
  cuentasRetiro = undefined
  error = false
  seleccion = undefined
  folios = undefined
  procesando = false
  ventanaBloqueda = false
  imprimirReverso = false
  redondearImportes = false

  constructor (NominasNominaDocumentosCheques, $window, $timeout) {
    this.NominasNominaDocumentosCheques = NominasNominaDocumentosCheques
    this.$window = $window
    this.$timeout = $timeout
  }

  $onChanges (changes) {
    if (changes.data) {
      this.cuentasRetiro = this.data.reduce((array, item) => {
        let existe = array.find((cuenta) => cuenta.id === item.id_cuenta_retiro)

        return existe ? array : [...array, {id: item.id_cuenta_retiro, descripcion: item.cuenta_retiro}]
      }, [])

      if (this.cuentasRetiro.length === 1) {
        this.seleccionarCuenta(this.cuentasRetiro[0])
      } else {
        this.cuentaRetiro = undefined
        this.seleccion = undefined
        this.folios = undefined
      }
    }
  }

  cerrar () {
    this.onClose()
  }

  filtrar (item) {
    return item.id_cuenta_retiro === this.cuentaRetiro.id
  }

  generar () {
    this.error = false
    this.procesando = true
    this.ventanaBloqueda = false

    return this.NominasNominaDocumentosCheques.get(this.idProyecto, this.idNomina, this.cuentaRetiro.id, this.seleccion, this.imprimirReverso, this.redondearImportes)
      .then(({data}) => {
        let url = this.$window.URL.createObjectURL(data)
        let window = this.$window.open(url, 'nomina_documentos_cheques')

        if (window) {
          window.focus()

          this.imprimirReverso = true
        } else {
          this.ventanaBloqueda = true
        }

        this.$timeout(() => (this.$window.URL.revokeObjectURL(url)), 3000)
      })
      .catch(() => (this.error = true))
      .finally(() => (this.procesando = false))
  }

  seleccionarCuenta (cuenta) {
    this.cuentaRetiro = cuenta

    const chequesSeleccionados = this.data
      .filter((item) => item.id_cuenta_retiro === cuenta.id)

    this.seleccion = chequesSeleccionados
      .sort((a, b) => (a.cheque_numero < b.cheque_numero) ? -1 : (a.cheque_numero > b.cheque_numero ? 1 : 0))
      .map((item) => item.id)

    this.folios = ranges(chequesSeleccionados, 'cheque_numero')
  }
}

module.component('nominasNominaDispersionPagosImprimirConfirmar', {
  controller: nominasNominaDispersionPagosImprimirConfirmarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/imprimir/confirmar/component.js